/* eslint-disable import/no-anonymous-default-export */
const config1 = {
  api_link: process.env.REACT_APP_API_LINK,
  consumer_key: process.env.REACT_APP_CONSUMER_KEY,
  uat_login: process.env.REACT_APP_UAT_LOGIN,
  app_id: process.env.REACT_APP_APP_ID,
  // azure_id: process.env.REACT_APP_APPINSIGHTS_KEY,
  datadog_application_id: process.env.REACT_APP_DATADOG_APPLICATION_ID,
  datadog_client_token: process.env.REACT_APP_DATADOG_CLIENT_TOKEN,
  datadog_service_name: process.env.REACT_APP_DATADOG_SERVICE_NAME,
  datadog_env: process.env.REACT_APP_DATADOG_ENV,
  hub_address: process.env.REACT_APP_HUB_ADDRESS,
  angular_api_link: process.env.REACT_APP_ANGULAR_API_LINK,
  // aws_id:process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  // aws_secret_key:process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  // aws_bucket_name:process.env.REACT_APP_BUCKET_NAME,
  // aws_region_name:process.env.REACT_APP_REGION_NAME,

  azure_maps_primary_key: process.env.REACT_APP_AZURE_MAPS_PRIMARY_KEY,
  azure_maps_client_id: process.env.REACT_APP_AZURE_MAPS_CLIENT_ID,
  azure_maps_secondary_key: process.env.REACT_APP_AZURE_MAPS_SECONDARY_KEY,
  cesium_ion_token: process.env.REACT_APP_CESIUM_ION_TOKEN,
};

export default { config1 };
